var version = "10.24.0";

export { version as v };
//# sourceMappingURL=package-cd92be1e.js.map
